<template>
  <div
    id="SearchDetailModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <!--begin::Form-->
      <form class="kt-form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>รหัสพนักงาน :</label>
                      <span class="form-control-plaintext">{{
                        auUserNO != null ? auUserNO : "-"
                      }}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>ชื่อพนักงาน :</label>
                      <span class="form-control-plaintext">{{
                        auUserName
                      }}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>เบอร์โทร :</label>
                      <span class="form-control-plaintext">{{
                        auTel != null ? auTel : "-"
                      }}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Email :</label>
                      <span class="form-control-plaintext">{{ auEmail }}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>ตำแหน่ง :</label>
                      <span class="form-control-plaintext">{{
                        auPosition != null ? auPosition : "-"
                      }}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>บริษัท :</label>
                      <span class="form-control-plaintext">{{
                        auCompany != null ? auCompany : "-"
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
export default {
  data: function() {
    return {
      auUserNO: null,
      auUserName: null,
      auTel: null,
      auEmail: null,
      auPosition: null,
      auCompany: null,
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });
    axios
      .get("/Api/Users/GetUser/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.auUserNO = response.data.employeeCode;
          self.auUserName = response.data.displayName;
          self.auTel = response.data.phoneNumber;
          self.auEmail = response.data.email;
          self.auPosition = response.data.position;
          self.auCompany = response.data.companyProfileName;
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลผู้อนุมัติที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลผู้อนุมัติได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    $("#SearchDetailModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        //self.$parent.reloadDataTable(false);
      })
      .modal("show");
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Master/Approver/ApproverUserInfo.vue